<app-panel>
    <app-btn-group title="Período">
        <button *ngFor="let periodo of opcoes" (click)="select(periodo)" type="button" class="btn btn-primary" [disabled]="disabled"
            [ngClass]="{'active': isSelected(periodo)}">{{periodo.descricao}}</button>
    </app-btn-group>
</app-panel>